import { api } from "./client";

export type Attachment = {
  id: string;
  mime: string;
  size_bytes: number;
  original_filename: string;
  status: "pending" | "committed" | "deleted";
  created_at: string;
};

export const attachmentsApi = {
  presign: (payload: { mime: string; size_bytes: number; original_filename: string }) =>
    api.post<{ attachment_id: string; upload_url: string; s3_key: string; expires_in: number }>(
      "/attachments/presign",
      payload,
    ),
  commit: (id: string) => api.post<Attachment>(`/attachments/${id}/commit`),
  downloadUrl: (id: string) =>
    api.get<{ download_url: string; expires_in: number; mime: string; original_filename: string }>(
      `/attachments/${id}`,
    ),
};

/**
 * Sube el archivo a Garage usando el presigned PUT. NO pasa por el backend.
 * Devuelve cuando termina (lanza si falla).
 */
export async function uploadFile(file: File, uploadUrl: string): Promise<void> {
  const res = await fetch(uploadUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": file.type },
  });
  if (!res.ok) {
    throw new Error(`Falló upload a storage: ${res.status} ${res.statusText}`);
  }
}
